module.exports = __webpack_public_path__ + "img/login-account-school.38cec0c2.png";